import WhatsappIcon from './WhatsappIcon';

export default WhatsappIcon;
